const CountriesUtils = () => {
    
    const countries = [
        { "countryName": "Afghanistan", "code": "AF" },
        { "countryName": "Albania", "code": "AL" },
        { "countryName": "Algeria", "code": "DZ" },
        { "countryName": "Andorra", "code": "AD" },
        { "countryName": "Angola", "code": "AO" },
        { "countryName": "Antigua and Barbuda", "code": "AG" },
        { "countryName": "Argentina", "code": "AR" },
        { "countryName": "Armenia", "code": "AM" },
        { "countryName": "Australia", "code": "AU" },
        { "countryName": "Austria", "code": "AT" },
        { "countryName": "Azerbaijan", "code": "AZ" },
        { "countryName": "Bahamas", "code": "BS" },
        { "countryName": "Bahrain", "code": "BH" },
        { "countryName": "Bangladesh", "code": "BD" },
        { "countryName": "Barbados", "code": "BB" },
        { "countryName": "Belarus", "code": "BY" },
        { "countryName": "Belgium", "code": "BE" },
        { "countryName": "Belize", "code": "BZ" },
        { "countryName": "Benin", "code": "BJ" },
        { "countryName": "Bhutan", "code": "BT" },
        { "countryName": "Bolivia", "code": "BO" },
        { "countryName": "Bosnia and Herzegovina", "code": "BA" },
        { "countryName": "Botswana", "code": "BW" },
        { "countryName": "Brazil", "code": "BR" },
        { "countryName": "Brunei", "code": "BN" },
        { "countryName": "Bulgaria", "code": "BG" },
        { "countryName": "Burkina Faso", "code": "BF" },
        { "countryName": "Burundi", "code": "BI" },
        { "countryName": "Cabo Verde", "code": "CV" },
        { "countryName": "Cambodia", "code": "KH" },
        { "countryName": "Cameroon", "code": "CM" },
        { "countryName": "Canada", "code": "CA" },
        { "countryName": "Central African Republic", "code": "CF" },
        { "countryName": "Chad", "code": "TD" },
        { "countryName": "Chile", "code": "CL" },
        { "countryName": "China", "code": "CN" },
        { "countryName": "Colombia", "code": "CO" },
        { "countryName": "Comoros", "code": "KM" },
        { "countryName": "Congo (Congo-Brazzaville)", "code": "CG" },
        { "countryName": "Costa Rica", "code": "CR" },
        { "countryName": "Croatia", "code": "HR" },
        { "countryName": "Cuba", "code": "CU" },
        { "countryName": "Cyprus", "code": "CY" },
        { "countryName": "Czechia (Czech Republic)", "code": "CZ" },
        { "countryName": "Democratic Republic of the Congo", "code": "CD" },
        { "countryName": "Denmark", "code": "DK" },
        { "countryName": "Djibouti", "code": "DJ" },
        { "countryName": "Dominica", "code": "DM" },
        { "countryName": "Dominican Republic", "code": "DO" },
        { "countryName": "Ecuador", "code": "EC" },
        { "countryName": "Egypt", "code": "EG" },
        { "countryName": "El Salvador", "code": "SV" },
        { "countryName": "Equatorial Guinea", "code": "GQ" },
        { "countryName": "Eritrea", "code": "ER" },
        { "countryName": "Estonia", "code": "EE" },
        { "countryName": "Eswatini (fmr. Swaziland)", "code": "SZ" },
        { "countryName": "Ethiopia", "code": "ET" },
        { "countryName": "Fiji", "code": "FJ" },
        { "countryName": "Finland", "code": "FI" },
        { "countryName": "France", "code": "FR" },
        { "countryName": "Gabon", "code": "GA" },
        { "countryName": "Gambia", "code": "GM" },
        { "countryName": "Georgia", "code": "GE" },
        { "countryName": "Germany", "code": "DE" },
        { "countryName": "Ghana", "code": "GH" },
        { "countryName": "Greece", "code": "GR" },
        { "countryName": "Grenada", "code": "GD" },
        { "countryName": "Guatemala", "code": "GT" },
        { "countryName": "Guinea", "code": "GN" },
        { "countryName": "Guinea-Bissau", "code": "GW" },
        { "countryName": "Guyana", "code": "GY" },
        { "countryName": "Haiti", "code": "HT" },
        { "countryName": "Holy See", "code": "VA" },
        { "countryName": "Honduras", "code": "HN" },
        { "countryName": "Hungary", "code": "HU" },
        { "countryName": "Iceland", "code": "IS" },
        { "countryName": "India", "code": "IN" },
        { "countryName": "Indonesia", "code": "ID" },
        { "countryName": "Iran", "code": "IR" },
        { "countryName": "Iraq", "code": "IQ" },
        { "countryName": "Ireland", "code": "IE" },
        { "countryName": "Israel", "code": "IL" },
        { "countryName": "Italy", "code": "IT" },
        { "countryName": "Ivory Coast", "code": "CI" },
        { "countryName": "Jamaica", "code": "JM" },
        { "countryName": "Japan", "code": "JP" },
        { "countryName": "Jordan", "code": "JO" },
        { "countryName": "Kazakhstan", "code": "KZ" },
        { "countryName": "Kenya", "code": "KE" },
        { "countryName": "Kiribati", "code": "KI" },
        { "countryName": "Kuwait", "code": "KW" },
        { "countryName": "Kyrgyzstan", "code": "KG" },
        { "countryName": "Laos", "code": "LA" },
        { "countryName": "Latvia", "code": "LV" },
        { "countryName": "Lebanon", "code": "LB" },
        { "countryName": "Lesotho", "code": "LS" },
        { "countryName": "Liberia", "code": "LR" },
        { "countryName": "Libya", "code": "LY" },
        { "countryName": "Liechtenstein", "code": "LI" },
        { "countryName": "Lithuania", "code": "LT" },
        { "countryName": "Luxembourg", "code": "LU" },
        { "countryName": "Madagascar", "code": "MG" },
        { "countryName": "Malawi", "code": "MW" },
        { "countryName": "Malaysia", "code": "MY" },
        { "countryName": "Maldives", "code": "MV" },
        { "countryName": "Mali", "code": "ML" },
        { "countryName": "Malta", "code": "MT" },
        { "countryName": "Marshall Islands", "code": "MH" },
        { "countryName": "Mauritania", "code": "MR" },
        { "countryName": "Mauritius", "code": "MU" },
        { "countryName": "Mexico", "code": "MX" },
        { "countryName": "Micronesia", "code": "FM" },
        { "countryName": "Moldova", "code": "MD" },
        { "countryName": "Monaco", "code": "MC" },
        { "countryName": "Mongolia", "code": "MN" },
        { "countryName": "Montenegro", "code": "ME" },
        { "countryName": "Morocco", "code": "MA" },
        { "countryName": "Mozambique", "code": "MZ" },
        { "countryName": "Myanmar", "code": "MM" },
        { "countryName": "Namibia", "code": "NA" },
        { "countryName": "Nauru", "code": "NR" },
        { "countryName": "Nepal", "code": "NP" },
        { "countryName": "Netherlands", "code": "NL" },
        { "countryName": "New Zealand", "code": "NZ" },
        { "countryName": "Nicaragua", "code": "NI" },
        { "countryName": "Niger", "code": "NE" },
        { "countryName": "Nigeria", "code": "NG" },
        { "countryName": "North Korea", "code": "KP" },
        { "countryName": "North Macedonia", "code": "MK" },
        { "countryName": "Norway", "code": "NO" },
        { "countryName": "Oman", "code": "OM" },
        { "countryName": "Pakistan", "code": "PK" },
        { "countryName": "Palau", "code": "PW" },
        { "countryName": "Palestine State", "code": "PS" },
        { "countryName": "Panama", "code": "PA" },
        { "countryName": "Papua New Guinea", "code": "PG" },
        { "countryName": "Paraguay", "code": "PY" },
        { "countryName": "Peru", "code": "PE" },
        { "countryName": "Philippines", "code": "PH" },
        { "countryName": "Poland", "code": "PL" },
        { "countryName": "Portugal", "code": "PT" },
        { "countryName": "Qatar", "code": "QA" },
        { "countryName": "Romania", "code": "RO" },
        { "countryName": "Russia", "code": "RU" },
        { "countryName": "Rwanda", "code": "RW" },
        { "countryName": "Saint Kitts and Nevis", "code": "KN" },
        { "countryName": "Saint Lucia", "code": "LC" },
        { "countryName": "Saint Vincent and the Grenadines", "code": "VC" },
        { "countryName": "Samoa", "code": "WS" },
        { "countryName": "San Marino", "code": "SM" },
        { "countryName": "Sao Tome and Principe", "code": "ST" },
        { "countryName": "Saudi Arabia", "code": "SA" },
        { "countryName": "Senegal", "code": "SN" },
        { "countryName": "Serbia", "code": "RS" },
        { "countryName": "Seychelles", "code": "SC" },
        { "countryName": "Sierra Leone", "code": "SL" },
        { "countryName": "Singapore", "code": "SG" },
        { "countryName": "Slovakia", "code": "SK" },
        { "countryName": "Slovenia", "code": "SI" },
        { "countryName": "Solomon Islands", "code": "SB" },
        { "countryName": "Somalia", "code": "SO" },
        { "countryName": "South Africa", "code": "ZA" },
        { "countryName": "South Korea", "code": "KR" },
        { "countryName": "South Sudan", "code": "SS" },
        { "countryName": "Spain", "code": "ES" },
        { "countryName": "Sri Lanka", "code": "LK" },
        { "countryName": "Sudan", "code": "SD" },
        { "countryName": "Suriname", "code": "SR" },
        { "countryName": "Sweden", "code": "SE" },
        { "countryName": "Switzerland", "code": "CH" },
        { "countryName": "Syria", "code": "SY" },
        { "countryName": "Tajikistan", "code": "TJ" },
        { "countryName": "Tanzania", "code": "TZ" },
        { "countryName": "Thailand", "code": "TH" },
        { "countryName": "Timor-Leste", "code": "TL" },
        { "countryName": "Togo", "code": "TG" },
        { "countryName": "Tonga", "code": "TO" },
        { "countryName": "Trinidad and Tobago", "code": "TT" },
        { "countryName": "Tunisia", "code": "TN" },
        { "countryName": "Turkey", "code": "TR" },
        { "countryName": "Turkmenistan", "code": "TM" },
        { "countryName": "Tuvalu", "code": "TV" },
        { "countryName": "Uganda", "code": "UG" },
        { "countryName": "Ukraine", "code": "UA" },
        { "countryName": "United Arab Emirates", "code": "AE" },
        { "countryName": "United Kingdom", "code": "GB" },
        { "countryName": "United States of America", "code": "US" },
        { "countryName": "Uruguay", "code": "UY" },
        { "countryName": "Uzbekistan", "code": "UZ" },
        { "countryName": "Vanuatu", "code": "VU" },
        { "countryName": "Venezuela", "code": "VE" },
        { "countryName": "Vietnam", "code": "VN" },
        { "countryName": "Yemen", "code": "YE" },
        { "countryName": "Zambia", "code": "ZM" },
        { "countryName": "Zimbabwe", "code": "ZW" }
    ];
    
    return { countries }
}

export default CountriesUtils